try {
    window.$ = window.jQuery = require('jquery');
    require('slick-carousel');
    require('magnific-popup');
    window.svg4everybody = require('svg4everybody');
} catch (e) {}

$(document).ready(function() {

    svg4everybody({});

    $('.navbar__link, .main-footer__navbar__link').click(function() {
        var scroll_el = $(this).attr('href');
        if ($(scroll_el).length != 0) {
            $('html, body').animate({
                scrollTop: $(scroll_el).offset().top
            }, 600);
        }
        return false;
    });



    $('.portfolio__slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        touchThreshold: 100,
        swipeToSlide: true,
        useTransform: false,
        speed: 200,
        responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 521,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.testimonials__slider').slick({
        dots: true,
        touchThreshold: 100,
        swipeToSlide: true,
        useTransform: false,
        speed: 200
    });

    $('.portfolio__link').on('click', function(e) {
        e.preventDefault();
        $.magnificPopup.open({
            items: {
                src: $(this).data('href')
            },
            preloader: true,
            type: 'ajax'
        }, 0);
    }).on("contextmenu", function(e) {
        e.preventDefault();
    });


    function winScrollY() {
        return document.body.scrollTop || document.documentElement.scrollTop;
    }

    function checkScrollTopButtonVisibility(scrollToTopButton) {
        if (winScrollY() > 700) {
            $(scrollToTopButton).show();
        } else {
            $(scrollToTopButton).hide();
        }
    }

    let scrollToTopButton = $('.scroll-to-top')[0];
    if (scrollToTopButton) {
        $(scrollToTopButton).on('click', function() {
            $('html, body').animate({
                scrollTop: 0
            }, 600);
        });
        window.addEventListener('scroll', function() {
            checkScrollTopButtonVisibility(scrollToTopButton);
        });
        checkScrollTopButtonVisibility(scrollToTopButton);
    }

    $('.toggle-navbar__btn').click(function() {
        $(this).toggleClass('_active');
        $('body').toggleClass('_open-menu');
        $('html').toggleClass('_open-menu');
        $('.navbar').toggleClass('_open');
    });

    $('.navbar__link').click(function() {
        if ($(window).width() < 768) {
            $('.toggle-navbar__btn').removeClass('_active');
            $('body').removeClass('_open-menu');
            $('.navbar').removeClass('_open');
        }
    });

    $('.scroll-down').on('click', function() {
        $('html, body').animate({
             scrollTop: $("#services-section").offset().top
        }, 600);
    });


    // var carouselParalax = document.querySelector('.carousel-header');
    //
    // var flkty = new Flickity('.carousel-header', {
    //     autoPlay: 5000,
    //     draggable: true,
    //     pageDots: false,
    //     imagesLoaded: true,
    //     percentPosition: false,
    //     contain: true,
    //     wrapAround: true,
    //     prevNextButtons: false,
    //     setGallerySize: false
    //
    // });
    //
    // var imgsParalaxLeft = carouselParalax.querySelectorAll('.carousel-cell .particle-bg-1 img');
    // var imgsParalaxRight = carouselParalax.querySelectorAll('.carousel-cell .particle-bg-2 img');
    // var docStyle = document.documentElement.style;
    // var transformProp = typeof docStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
    //
    // flkty.on('scroll', function(progress) {
    //     flkty.slides.forEach(function(slide, i) {
    //         var imgParalaxLeft = imgsParalaxLeft[i];
    //         var imgParalaxRight = imgsParalaxRight[i];
    //         var x = (slide.target + flkty.x) * -1 / 8;
    //         var y = (slide.target + flkty.x) * 1 / 8;
    //
    //         if (imgParalaxLeft) {
    //             imgParalaxLeft.style[transformProp] = 'translateX(' + x + 'px)';
    //         }
    //
    //         if (imgParalaxRight) {
    //             imgParalaxRight.style[transformProp] = 'translateX(' + y + 'px)';
    //         }
    //     });
    // });
});



// WEBPACK FOOTER //
// ./resources/js/landing.js